// Form field name used only on the client. NoteCreate strips it before the
// note is saved and, when it is filled, also records a purchase signal.
export const NOTE_SIGNAL_FIELD = "purchase_signal_type";

// Separates the client-only signal choice from the note payload.
export const splitNoteSignal = <T extends Record<string, unknown>>(
  data: T,
): { note: Omit<T, typeof NOTE_SIGNAL_FIELD>; signalType: string | null } => {
  const { [NOTE_SIGNAL_FIELD]: signalType, ...note } = data;
  return {
    note,
    signalType:
      typeof signalType === "string" && signalType !== "" ? signalType : null,
  };
};
